/**
 * Module dependencies.
 */

import { color, units } from 'src/styles/utils';
import { downloadFileFromUrl } from 'src/core/utils/downloads';
import { useTranslate } from 'src/core/utils/translator';
import IconButton from 'src/components/core/buttons/icon-button';
import React, { ReactElement } from 'react';
import downloadImageIcon from 'src/assets/svg/download-image.svg';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string,
  url: string
};

/**
 * `Button` styled component.
 *
 * Figma (`Button`, node 10218:73609): white 32px circle with the download
 * glyph exported from Figma at its root size (14.6637px wide;
 * `svg-inline-loader` strips the root width/height, so it is set here).
 * It is heavier than `download.svg`, so it is a separate asset.
 */

const Button = styled(IconButton)`
  align-items: center;
  background-color: ${color('white')};
  border: 1px solid ${color('white')};
  border-radius: 100px;
  display: flex;
  height: ${units(4)};
  justify-content: center;
  width: ${units(4)};
`;

/**
 * `ImageDownloadButton` component.
 */

const ImageDownloadButton = ({ className, url }: Props): ReactElement => {
  const { translate } = useTranslate();
  const label = translate('common:cardActions.download');

  return (
    <Button
      aria-label={label}
      className={className}
      icon={downloadImageIcon}
      iconSize={'14.6637px'}
      label={label}
      labelAlign={'end'}
      onClick={() => downloadFileFromUrl(url)}
    />
  );
};

/**
 * Export `ImageDownloadButton` component.
 */

export default ImageDownloadButton;
